import { createAction } from '@reduxjs/toolkit';

import { AssignableTicketsFormState } from './assign-tickets';

export const storeAssignedTickets = createAction(
  'assignTickets/store',
  (tickets: AssignableTicketsFormState['tickets']) => {
    return {
      payload: Object.entries(tickets).map(([fieldsetId, details]) => {
        const [ticketId, id] = fieldsetId.split('__');
        return {
          ticketId,
          id,
          ...details,
        };
      }),
    };
  },
);

export const setSelfAssignedTicket = createAction<Nullable<string>>(
  'assignTickets/selfAssignTicket',
);
